import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormComponentLookup, EntryConfigInterface } from '@ptl/forms';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import moment from 'moment';
import { FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('custom-radio-input')
@Component({
    selector: 'app-custom-radio-input',
    templateUrl: './custom-radio-input.component.html',
    styleUrls: ['./custom-radio-input.component.scss'],
    standalone: false
})
export class CustomRadioInputComponent extends FormEntryComponentClass implements OnInit, AfterViewInit {

  radioFormGroups: {};

  constructor() {
    super();
  }


  textBoxNeeded(val: string): boolean {
    if (
      this.entry.custom &&
      this.entry.custom.textboxOptions &&
      this.entry.custom.textboxOptions.includes(val)
    ) {
      return true;
    }
    return false;
  }

  toFormGroup(entries: EntryConfigInterface[]) {

    const formGroupByPath = {};
    // const group: any = {};

    entries.forEach((entry: EntryConfigInterface) => {

      if (entry.formControlAttributes && entry.formControlAttributes.connectPath) {
        formGroupByPath[entry.formControlAttributes.connectPath] = formGroupByPath[entry.formControlAttributes.connectPath] ?
          formGroupByPath[entry.formControlAttributes.connectPath] : {};
        const disabled = entry.formControlAttributes && entry.formControlAttributes.disabled;

        if (entry.base.componentType === 'date-input') {
          formGroupByPath[entry.formControlAttributes.connectPath][entry.formControlAttributes.formControlName] =
            new UntypedFormControl({ value: moment(), disabled: disabled });
        } else {
          formGroupByPath[entry.formControlAttributes.connectPath][entry.formControlAttributes.formControlName] =
            new UntypedFormControl({ value: null, disabled: disabled });
        }
      }

    });

    for (const formGroup in formGroupByPath) {
      if (formGroupByPath.hasOwnProperty(formGroup)) {
        formGroupByPath[formGroup] = new UntypedFormGroup(formGroupByPath[formGroup]);
      }
    }

    return formGroupByPath;
  }
}
